import React from 'react';

export class Reviews extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      slideIndex: 0,
    };

    // Привязка методов для использования в обработчиках событий
    this.showSlide = this.showSlide.bind(this);
    this.handlePrevClick = this.handlePrevClick.bind(this);
    this.handleNextClick = this.handleNextClick.bind(this);
  }

  showSlide(index) {
    if (index < 0) {
      this.setState({ slideIndex: this.props.reviews.length - 1 });
    } else if (index >= this.props.reviews.length) {
      this.setState({ slideIndex: 0 });
    } else {
      this.setState({ slideIndex: index });
    }
  }

  handlePrevClick() {
    this.showSlide(this.state.slideIndex - 1);
  }

  handleNextClick() {
    this.showSlide(this.state.slideIndex + 1);
  }

  render() {
    const { reviews } = this.props; // Получаем reviews из props
    const transformStyle = `translateX(-${this.state.slideIndex * 100}%)`;

    return (
      <div className='reviews'>  
      <h1>Отзывы</h1>
      <h3>Здесь вы можете прочитать о впечатлениях наших гостей </h3>
      <div className='revies-background'>
      <div className="reviews-container">
        

        <div className="slider-wrapper">
          <button className="slider-arrow prev" aria-label="Предыдущий отзыв" onClick={this.handlePrevClick}>
          <i className="fas fa-chevron-left"></i>
          </button>
          <div className="slider" style={{ transform: transformStyle }}>
            {reviews.map((review, index) => (
              <div className="slide" key={index}>
                <div className="review">
                  <div className="review-header">
                    <span className="author">{review.author}</span>
                    <span className="date">{review.date}</span>
                  </div>
                  <img src={review.image} alt={`Фотография ${review.author}`} />
                  <p>{review.text}</p>
                </div>
              </div>
            ))}
          </div>
          <button className="slider-arrow next" aria-label="Следующий отзыв" onClick={this.handleNextClick}>
          <i className="fas fa-chevron-right"></i>
          </button>
        </div>

      </div>
      </div>
      </div>
    );
  }
}
export default Reviews